export const SHIPMENT_LINE_ITEM_SUCCESS_TITLE = 'Success';
export const SHIPMENT_LINE_ITEM_ERROR_TITLE = 'Error';
export const LINE_ITEM_DELETE_SUCCESS_MESSAGE = 'Line item deleted.';
export const LINE_ITEM_DELETE_ERROR_MESSAGE = 'There was an error deleting the line item.';
export const PRODUCT_CREATE_SUCCESS_MESSAGE = 'Product created.';
export const PRODUCT_UPDATE_SUCCESS_MESSAGE = 'Product updated.';
